import { ThemeOptions } from '@mui/material/styles';

export const fonts = (): ThemeOptions => ({
	fonts: [
		{
			family: 'Open Sans',
			style: 'normal',
			display: 'swap',
			weight: 300,
			src: `local("Open Sans Light"),
      local("OpenSans-Light"),
      url("https://cdn.homedepot.com.mx/assets/fonts/Open_Sans/OpenSans-Light.woff2") 
      format("woff2")
      `,
			unicodeRange: undefined,
		},
		{
			family: 'Open Sans',
			style: 'normal',
			display: 'swap',
			weight: 400,
			src: `
      local("Open Sans"),
      local("Open Sans Regular"),
      local("OpenSans-Regular"),
      url("https://cdn.homedepot.com.mx/assets/fonts/Open_Sans/OpenSans-Regular.woff2") 
      format("woff2")
      `,
			unicodeRange: undefined,
		},
		{
			family: 'Open Sans',
			style: 'normal',
			display: 'swap',
			weight: 600,
			src: `
      local("Open Sans SemiBold"),
      local("OpenSans-SemiBold"),
      url("https://cdn.homedepot.com.mx/assets/fonts/Open_Sans/OpenSans-SemiBold.woff2") 
      format("woff2")
      `,
			unicodeRange: undefined,
		},
		{
			family: 'Open Sans',
			style: 'normal',
			display: 'swap',
			weight: 700,
			src: `
      local("Open Sans Bold"),
      local("OpenSans-Bold"),
      url("https://cdn.homedepot.com.mx/assets/fonts/Open_Sans/OpenSans-Bold.woff2") 
      format("woff2")
      `,
			unicodeRange: undefined,
		},
		{
			family: 'HelveticaNeue_THD',
			style: 'normal',
			display: 'swap',
			weight: 400,
			src: `
      local("Helvetica Neue LT Std"),
      url("https://cdn.homedepot.com.mx/assets/fonts/HelveticaNeueLTStd-HvCn.woff2") 
      format("woff2")
      `,
			unicodeRange: undefined,
		},
		{
			family: 'HelveticaNeue_THD',
			style: 'normal',
			display: 'swap',
			weight: 600,
			src: `
      local("Helvetica Neue LT Std"),
      url("https://cdn.homedepot.com.mx/assets/fonts/HelveticaNeueLTStd-BlkCn.woff2") 
      format("woff2")
      `,
			unicodeRange: undefined,
		},
		{
			family: 'Futura',
			style: 'normal',
			display: 'swap',
			weight: 400,
			src: `
      local("Futura"),
      url("https://cdn.homedepot.com.mx/assets/fonts/Futura.ttf")
      format("ttf")
      `,
			unicodeRange: undefined,
		},
		{
			family: 'Futura',
			style: 'normal',
			display: 'swap',
			weight: 600,
			src: `
      local("Futura"),
      url("https://cdn.homedepot.com.mx/assets/fonts/Futura.ttf")
      format("ttf")
      `,
			unicodeRange: undefined,
		},
	],
});
